define({
        // Toolstrip and QAB context menu
        toolstripLabel: "ツールストリップ",
        showLabel: "ラベルの表示",
        hideLabel: "ラベルの非表示",
        QAB: "クイック アクセス ツール バー",
        removeFromQAB: "クイック アクセス ツール バーから削除",
        addToQAB: "クイック アクセス ツール バーに追加",
        qabDefaultDropdownLabel: "共通のコントロール",
        qabOverflowDropdownLabel: "その他のコントロール",
        restoreFactoryControls: "既定の設定に戻す",
        restoreFactoryControlsDialogTitle: "復元の確認",
        restoreFactoryControlsDialogMessage: "すべてのカスタマイズが削除され、クイック アクセス ツール バーが既定の設定に戻されます。​",
        minimizeToolstrip: "ツールストリップの最小化",
        restoreToolstrip: "ツールストリップの復元",
        closeWidget: "\"${0}\" タブを閉じる",
        removeWidget: "\"${0}\" をギャラリーから削除",
        homeButtonLabel: "MATLAB ホーム",

        // Gallery
        gallerySearch: "検索",
        showMore: "さらに表示",
        noSearchMatchNode:"検索に一致する項目はありません。",
        emptyCategoryPlaceholder: "このカテゴリは空です",
        listView: "リスト表示",
        iconView: "アイコン表示",
        navTop: "カテゴリを一番上に移動",
        navBottom: "カテゴリを一番下に移動",
        favStarAdd: "お気に入りに追加",
        favStarRemove: "お気に入りから削除",
        editWidget: "\"${0}\" の編集",
        favoritesCategoryTitle: "お気に入り"
});